import TextareaAutosizeBase, {
  TextareaAutosizeProps,
} from 'react-textarea-autosize';

export function TextareaAutosize({
  ...rest
}: TextareaAutosizeProps): JSX.Element {
  return <TextareaAutosizeBase {...rest} />;
}
